<template>
  <div>
    <data-list
      :data="data"
      :columns="column"
      :page="page"
      :table-style="{ name: 'mixture' }"
      :page-size="page.pageSize"
      :loading="loading"
      @page-size-changed="pageSizeChanged"
      @page-changed="pageChanged"
      @sort-change="sortChange"
    ></data-list>
  </div>
</template>

<script>
import api from '@/backend/apiConfig/apiConfig'
import listPageCreate from '@/mixins/listPageCreate'

const list = listPageCreate({
  searchConfig: {
    api: api.setmeal.roleList,
    method: 'POST',
  },
  getQuery(obj) {
    return _.assign(obj, { customerId: 0 })
  },
})
export default {
  mixins: [list],
  data() {
    return {
      column: [],
    }
  },
  mounted() {
    this.setColumn()
    this.query()
  },
  methods: {
    setColumn() {
      let that = this
      this.column = [
        {
          label: '角色',
          bind: 'name',
        },
        {
          label: '角色描述',
          bind: 'desc',
        },
        {
          label: '操作',
          type: 'iconbutton',
          align: 'center',
          iconlist: [
            {
              name: 'bianji',
              message: '编辑',
              style: {
                color: '#5CAFFF',
              },
              callback(row) {
                let { name, desc } = row
                sessionStorage.setItem('row', JSON.stringify({ name, desc }))
                that.$router.push({
                  name: 'addRole',
                  query: {
                    edit: true,
                    roleId: row.id,
                  },
                })
              },
            },
          ],
        },
      ]
    },
  },
  components: {},
}
</script>

<style>
</style>
